import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import GlassCard from '../UI/GlassCard';
import SectionHeader from '../UI/SectionHeader';

const Insights = () => {
  return (
    <Box id="insights" sx={{ py: 16 }}>
      <Container maxWidth="lg" sx={{ px: 3 }}>
        <SectionHeader number="04" title="Additional Info" description="Education & Languages" />
        
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)' }, gap: 4 }}>
          <GlassCard sx={{ p: 5, '&:hover h4': { color: 'primary.main' } }}>
            <Typography sx={{ fontFamily: 'mono', fontSize: '10px', color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.1em', mb: 3 }}>
              University • GPA: 3.16
            </Typography>
            <Typography variant="h4" sx={{ fontSize: '1.5rem', fontWeight: 700, mb: 2, transition: 'color 0.3s' }}>
              Bachelors in Software Engineering
            </Typography>
            <Typography sx={{ color: 'text.secondary', fontSize: '0.875rem', lineHeight: 1.7, mb: 3 }}>
              Near East University - Cyprus (Assessed by UHR). 2020 - 2024. Successfully built a MERN Stack AI Aided Book eStore as a graduation project.
            </Typography>
          </GlassCard>

          <GlassCard sx={{ p: 5, '&:hover h4': { color: 'primary.main' } }}>
            <Typography sx={{ fontFamily: 'mono', fontSize: '10px', color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.1em', mb: 3 }}>
              Linguistics • Communication
            </Typography>
            <Typography variant="h4" sx={{ fontSize: '1.5rem', fontWeight: 700, mb: 2, transition: 'color 0.3s' }}>
              Multilingual Proficiency
            </Typography>
            <Typography sx={{ color: 'text.secondary', fontSize: '0.875rem', lineHeight: 1.7, mb: 3 }}>
              • English - Fluent <br />
              • Arabic - Fluent <br />
              • Swedish - Conversational
            </Typography>
          </GlassCard>
        </Box>
      </Container>
    </Box>
  );
};

export default Insights;